import React from 'react';
import { Box, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableHeadSearchField, TableHeadSortToggle } from '../../../../../../ui-kit';
import { AdditionalTableHeadProps } from '../../../../../../ui-kit/Table/TableHead';
import { NameCellProps } from '../types';

type WarehouseNameHeaderContentProps = AdditionalTableHeadProps & NameCellProps;

const WarehouseNameHeaderContent = ({
    nameOrSku,
    setNameOrSku,
    setNameSort,
    nameSort,
    isActionActive,
    index,
    checked,
    indeterminate,
    onChange,
}: WarehouseNameHeaderContentProps) => {
    const { t } = useTranslation();

    const isFirstCell = index === 0;
    let nameCellContent = (
        <Box display='flex' alignItems='center' flexGrow={1}>
            <Box pl={isActionActive && isFirstCell ? 0 : 1} pr={1}>
                <TableHeadSortToggle setSort={setNameSort} sort={nameSort} />
            </Box>
            <TableHeadSearchField
                fullWidth
                margin='dense'
                value={nameOrSku}
                onChange={setNameOrSku}
                placeholder={t('Name')}
            />
        </Box>
    );
    if (isActionActive && isFirstCell) {
        nameCellContent = isActionActive && isFirstCell
            ? (
                <Box pl={2} display="flex" alignItems="center">
                    <Checkbox
                        onChange={onChange}
                        checked={checked}
                        indeterminate={indeterminate}
                        style={{ padding: '0px', marginRight: '8px' }}
                        color='primary'
                    />

                    {nameCellContent}
                </Box>
            ) : nameCellContent;
    }
    return nameCellContent;
};

export default WarehouseNameHeaderContent;
